import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  ExportPointsTransactionsRequest,
  pointsTransactionsService,
} from '@aslanpay/portal-common-lib';

const useDownloadGiftingReports = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, ExportPointsTransactionsRequest>) => {
  return useMutation<unknown, Error, ExportPointsTransactionsRequest>(
    ({ ids, transactionGroupIds, size = 50000 }: ExportPointsTransactionsRequest) => {
      // Single employee download - prioritize ids when provided
      if (ids && ids.length > 0 && (!transactionGroupIds || transactionGroupIds.length === 0)) {
        return pointsTransactionsService.exportPointsTransactions({ ids, size });
      }

      // Group download - use transactionGroupIds when provided
      if (transactionGroupIds && transactionGroupIds.length > 0) {
        return pointsTransactionsService.exportPointsTransactions({ transactionGroupIds, size });
      }

      // Fallback to ids if no group IDs are provided
      return pointsTransactionsService.exportPointsTransactions({ ids, size });
    },
    { onSuccess, onError }
  );
};

export default useDownloadGiftingReports;
